import styled from 'styled-components';

const StyledCircleFollow = styled.div`
  position: relative;
 .line-back{
   position: absolute;
    left: 50%;
    top: 0;
    width: 2px;
    height: 100vh;
    border: 1px solid #BAB9B5;
    transform: translate(-50%, 0);
    z-index: 2;
  }
  .circle-follow{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    z-index: 2;
    background-color: ${props => props.theme.colors.green_secondary};
  }
  @media screen and (max-width: 767px){
    display: none;
  }
`;

export {
  StyledCircleFollow,
};

